import historySaga from './history';
import endpointSaga from './endpoint';
import ruleSaga from './rule';

export default [
  ...historySaga,
  ...endpointSaga,
  ...ruleSaga,
];
